import React from 'react';
import { styled, Theme } from '@mui/material';

// Loading dots styled components
const DotsContainer = styled('section')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
  width: '100%',
  paddingLeft: '8px',
});

const Dot = styled('div')(({ theme }: { theme: Theme }) => ({
  height: '8px',
  width: '8px',
  marginRight: '6px',
  borderRadius: '6px',
  backgroundColor: theme.palette.primary.light,
  animation: 'pulse 1s infinite ease-in-out',
  '&:last-child': {
    marginRight: 0,
  },
  '&:nth-of-type(1)': {
    animationDelay: '-0.2s',
  },
  '&:nth-of-type(2)': {
    animationDelay: '-0.1s',
  },
  '&:nth-of-type(3)': {
    animationDelay: '0s',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(0.8)',
      backgroundColor: theme.palette.primary.light,
      boxShadow: `0 0 0 0 ${theme.palette.primary.light}4D`,
    },
    '50%': {
      transform: 'scale(1.2)',
      backgroundColor: theme.palette.primary.main,
      boxShadow: `0 0 0 6px ${theme.palette.primary.light}00`,
    },
    '100%': {
      transform: 'scale(0.8)',
      backgroundColor: theme.palette.primary.light,
      boxShadow: `0 0 0 0 ${theme.palette.primary.light}4D`,
    },
  },
}));

export const LoadingDots = (): JSX.Element => (
  <DotsContainer>
    <Dot />
    <Dot />
    <Dot />
  </DotsContainer>
);

export default LoadingDots;
